import { render, staticRenderFns } from "./VendorCodeDropdown.vue?vue&type=template&id=16c5c6a4&scoped=true"
import script from "./VendorCodeDropdown.vue?vue&type=script&lang=js"
export * from "./VendorCodeDropdown.vue?vue&type=script&lang=js"
import style0 from "./VendorCodeDropdown.vue?vue&type=style&index=0&id=16c5c6a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c5c6a4",
  null
  
)

export default component.exports